/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StripeSessionDto,
    StripeSessionDtoFromJSON,
    StripeSessionDtoFromJSONTyped,
    StripeSessionDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface HostBoughtCredit
 */
export interface HostBoughtCredit {
    /**
     * 
     * @type {number}
     * @memberof HostBoughtCredit
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof HostBoughtCredit
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof HostBoughtCredit
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof HostBoughtCredit
     */
    creditId?: number;
    /**
     * 
     * @type {Array<StripeSessionDto>}
     * @memberof HostBoughtCredit
     */
    stripeSessions?: Array<StripeSessionDto>;
}

export function HostBoughtCreditFromJSON(json: any): HostBoughtCredit {
    return HostBoughtCreditFromJSONTyped(json, false);
}

export function HostBoughtCreditFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostBoughtCredit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'creditId': !exists(json, 'credit_id') ? undefined : json['credit_id'],
        'stripeSessions': !exists(json, 'stripe_sessions') ? undefined : ((json['stripe_sessions'] as Array<any>).map(StripeSessionDtoFromJSON)),
    };
}

export function HostBoughtCreditToJSON(value?: HostBoughtCredit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'price': value.price,
        'amount': value.amount,
        'credit_id': value.creditId,
        'stripe_sessions': value.stripeSessions === undefined ? undefined : ((value.stripeSessions as Array<any>).map(StripeSessionDtoToJSON)),
    };
}

